export enum NavigationItemTypes {
  Divider = 'Divider',
  Item = 'Item',
}
